import {DragSource} from '@wandb/weave/common/containers/DragDropContainer';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import iconClock from '../../assets/ic-clock.svg';
import iconEye from '../../assets/ic-eye.svg';
import EditableImage from '../../components/EditableImage';

export const CARD_IMG_SIZE_PX = 150;

const BREAKPOINT_ONE_COL_PX = 1240;

export const Grid = styled.div`
  display: grid;
  grid-gap: calc(${globals.spu} * 3.5);

  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
Grid.displayName = 'S.Grid';

export const Card = styled(Link)`
  &:nth-child(odd) {
    grid-column: 1 / span 1;
  }
  &:nth-child(even) {
    grid-column: 2 / span 1;
  }

  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    &:nth-child(1n) {
      grid-column: 1 / span 1;
    }
  }
`;
Card.displayName = 'S.Card';

export const CardImg = styled(EditableImage)`
  height: ${CARD_IMG_SIZE_PX}px;
  border-radius: 8px;
  margin: 0;
`;
CardImg.displayName = 'S.CardImg';

export const CardText = styled.div`
  position: relative;
`;
CardText.displayName = 'S.CardText';

const clampStyles2 = css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const clampStyles1 = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  ${clampStyles2}
  font-size: calc(${globals.fontSizeStandard} * 1.25);
`;
CardHeader.displayName = 'S.CardHeader';

export const CardDescription = styled.div`
  ${clampStyles2}
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  margin-top: calc(${globals.spu} * 1);
`;
CardDescription.displayName = 'S.CardDescription';

export const CardMeta = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 0.75);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
CardMeta.displayName = 'S.CardMeta';

export const CardMetaLeft = styled.div`
  display: flex;
  align-items: center;
`;
CardMetaLeft.displayName = 'S.CardMetaLeft';

export const CardMetaRight = styled.div`
  display: flex;
  align-items: center;
`;
CardMetaRight.displayName = 'S.CardMetaRight';

export const ViewsIcon = styled.img.attrs({src: iconEye})`
  margin-right: 3px;
`;
ViewsIcon.displayName = 'S.ViewsIcon';

export const UpdatedAtIcon = styled.img.attrs({src: iconClock})`
  margin-right: 3px;
`;
UpdatedAtIcon.displayName = 'S.UpdatedAtIcon';

export const ClampedLine = styled.span`
  ${clampStyles1};
`;
ClampedLine.displayName = 'S.ClampedLine';

export const CardActions = styled.div`
  position: absolute;
  top: calc(${globals.spu} * 1.375);
  right: calc(${globals.spu} * 1.375);
`;
CardActions.displayName = 'S.CardActions';

export const DragHandle = styled(Icon).attrs({name: 'drag-grip'})`
  font-size: calc(${globals.fontSizeStandard} * 1.75);
  border-radius: 50%;
  color: ${globals.gray300};
  user-select: none;
  cursor: grab;
  &&&:hover {
    background: ${globals.gray100};
    color: ${globals.black};
  }
  &:active {
    cursor: grabbing;
  }
`;
DragHandle.displayName = 'S.DragHandle';

export const CardContent = styled(DragSource)`
  background: ${globals.WHITE};
  position: relative;
  display: grid;
  grid-template-columns: ${CARD_IMG_SIZE_PX}px minmax(0, 1fr);
  grid-gap: calc(${globals.spu} * 1.375);

  color: ${globals.TEXT_PRIMARY_COLOR};
  &:hover {
    color: ${globals.TEXT_PRIMARY_COLOR};
  }

  border: 1px solid ${globals.MOON_200};
  &:hover {
    border-color: ${globals.TEAL_450};
  }
  border-radius: 8px;

  padding: calc(${globals.spu} * 1.375);

  &:hover ${DragHandle} {
    color: ${globals.MOON_600};
  }

  transition: border-color 0.3s;
`;
CardContent.displayName = 'S.CardContent';
